import { CompanyEmploymentTypes } from '@types';
import { WorkTemplateFormContext } from '../../../forms/shared/work-template-form.types';

export const useWorkTemplateCreateDefaults = (
  defaultValues: Partial<WorkTemplateFormContext> | undefined,
  companyEmploymentType: CompanyEmploymentTypes
): WorkTemplateFormContext => ({
  ...defaultValues,
  isFlexPoolOnly: defaultValues?.isFlexPoolOnly ?? false,
  isFreelanceOrtApplicable: defaultValues?.isFreelanceOrtApplicable ?? false,
  isTempworkOrtApplicable: defaultValues?.isTempworkOrtApplicable ?? false,
  department: defaultValues?.department,
  workName: defaultValues?.workName,
  hourlyRate: defaultValues?.hourlyRate,
  mutableUntilHours: defaultValues?.mutableUntilHours,
  cla: defaultValues?.cla,
  breakMinutes: defaultValues?.breakMinutes,
  jobType: defaultValues?.jobType,
  jobCertificates: defaultValues?.jobCertificates ?? [],
  flexPool: defaultValues?.flexPool,
  flexPools: defaultValues?.flexPools ?? [],
  vat: defaultValues?.vat,
  jobRequirements: defaultValues?.jobRequirements,
  shortDescription: defaultValues?.shortDescription,
  longDescription: defaultValues?.longDescription,
  descriptionLegalRequirements: defaultValues?.descriptionLegalRequirements,
  location: defaultValues?.location ?? null,
  imageUrl: defaultValues?.imageUrl,
  contactName: defaultValues?.contactName,
  contactPhoneWithPrefix: defaultValues?.contactPhoneWithPrefix,
  costCenter: defaultValues?.costCenter,
  isFreelance: companyEmploymentType.offersFreelanceWork,
  isTempwork: companyEmploymentType.offersTempWork,
  isEmployee: companyEmploymentType.offersEmployeeWork,
  startTime: defaultValues?.startTime ?? null,
  endTime: defaultValues?.endTime ?? null,
  maxClaimants: defaultValues?.maxClaimants ?? null,
});
